/* eslint-disable no-undef */
(function (d, u, ac) {
	const consentMode = localStorage.getItem("consentMode");
	if (consentMode) {
		const { ad_storage: marketing, analytics_storage: analytics } = JSON.parse(consentMode);
		if (marketing === "granted" && analytics === "granted") {
			const s = d.createElement("script");
			s.type = "text/javascript";
			s.src = "https://a.omappapi.com/app/js/api.min.js";
			s.async = true;
			s.dataset.user = u;
			s.dataset.account = ac;
			d.getElementsByTagName("head")[0].appendChild(s);
		}
	}
})(document, monsterOptinU, monsterOptinAC);
